import CatalogoClienteListStore from './CatalogoClienteListStore';
import CatalogoClienteUploadStore from './CatalogoClienteUploadStore';

const CatalogoClienteStore = {
  archivos: CatalogoClienteListStore,
  upload: CatalogoClienteUploadStore,
};

export default CatalogoClienteStore;
